"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultFilterFunc = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _downshift = require("downshift");

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _common = require("../../../helpers/common");

var _propTypes2 = require("../../../helpers/prop-types");

var _Button = _interopRequireDefault(require("../Button"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _LoadingSpinner = _interopRequireDefault(require("../LoadingSpinner"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var defaultFilterFunc = function defaultFilterFunc(searchTerm, option) {
  return (0, _common.textSearchCompareByWord)(searchTerm, option === null || option === void 0 ? void 0 : option.label);
};
/**
 * Autocomplete can be used as a controlled or uncontrolled component,
 * depending on the props passed in. See the story for details. Most often
 * you will want to use it as a controlled component if you are performing
 * an async search against the backend (in which case the isLoading prop)
 * would come in handy as well
 */


exports.defaultFilterFunc = defaultFilterFunc;

function Autocomplete(props) {
  var initialSearchTerm = props.initialSearchTerm,
      searchTerm = props.searchTerm,
      onSearchChange = props.onSearchChange,
      name = props.name,
      items = props.items,
      onItemSelected = props.onItemSelected,
      placeholder = props.placeholder,
      isLoading = props.isLoading,
      isDisabled = props.isDisabled,
      size = props.size,
      shouldShowChangeButton = props.shouldShowChangeButton,
      shouldAllowArbitraryInput = props.shouldAllowArbitraryInput,
      filterFunc = props.filterFunc,
      rest = _objectWithoutProperties(props, ["initialSearchTerm", "searchTerm", "onSearchChange", "name", "items", "onItemSelected", "placeholder", "isLoading", "isDisabled", "size", "shouldShowChangeButton", "shouldAllowArbitraryInput", "filterFunc"]);

  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedItem = _useState2[0],
      setSelectedItem = _useState2[1];

  var _useState3 = (0, _react.useState)(initialSearchTerm),
      _useState4 = _slicedToArray(_useState3, 2),
      localSearchTerm = _useState4[0],
      setLocalSearchTerm = _useState4[1];

  var resolvedSearchTerm = searchTerm || localSearchTerm;
  var resolvedOnSearchChange = onSearchChange || setLocalSearchTerm;
  var filteredItems = (0, _lodash.filter)(items, function (option) {
    return filterFunc(resolvedSearchTerm, option);
  });

  var _useCombobox = (0, _downshift.useCombobox)({
    items: filteredItems,
    selectedItem: selectedItem,
    itemToString: function itemToString(item) {
      return item === null || item === void 0 ? void 0 : item.label;
    },
    inputValue: resolvedSearchTerm,
    onInputValueChange: function onInputValueChange(changes) {
      resolvedOnSearchChange(changes.inputValue);
    },
    onSelectedItemChange: function onSelectedItemChange(changes) {
      var selectedItem = changes.selectedItem;
      onItemSelected(selectedItem);
      setSelectedItem(selectedItem);
      resolvedOnSearchChange(selectedItem.label);
    },
    onStateChange: function onStateChange(changes) {
      if (changes.type === _downshift.useCombobox.stateChangeTypes.InputBlur && selectedItem) {
        var value = shouldAllowArbitraryInput ? resolvedSearchTerm : selectedItem.label;
        resolvedOnSearchChange(value);
      }
    }
  }),
      isOpen = _useCombobox.isOpen,
      openMenu = _useCombobox.openMenu,
      getMenuProps = _useCombobox.getMenuProps,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      highlightedIndex = _useCombobox.highlightedIndex,
      getItemProps = _useCombobox.getItemProps;

  return _react.default.createElement("div", _extends({
    className: "relative"
  }, rest), _react.default.createElement("div", _extends({
    className: "relative"
  }, getComboboxProps()), _react.default.createElement(_TextField.default, _extends({}, getInputProps({
    ref: inputRef,
    onFocus: function onFocus() {
      if (!isOpen) openMenu();
    }
  }), {
    name: name,
    placeholder: placeholder,
    disabled: isDisabled,
    size: size
  })), !isDisabled && shouldShowChangeButton ? _react.default.createElement("div", {
    className: "absolute inset-y-0 flex items-center",
    style: {
      right: 14
    }
  }, _react.default.createElement(_Button.default, {
    className: "text-xs",
    variant: "text",
    onClick: function onClick() {
      inputRef.current.focus();
      openMenu();
      resolvedOnSearchChange('');
    }
  }, "CHANGE")) : null), _react.default.createElement("div", {
    className: "absolute z-40 w-full",
    style: {
      paddingTop: 1
    }
  }, _react.default.createElement("ul", _extends({
    className: "focus:outline-none bg-white shadow overflow-y-auto",
    style: {
      maxHeight: 180
    }
  }, getMenuProps()), isOpen && (isLoading ? _react.default.createElement("div", {
    className: "p-4 flex justify-center items-center"
  }, _react.default.createElement(_LoadingSpinner.default, null)) : filteredItems.map(function (item, index) {
    return _react.default.createElement("li", _extends({
      key: item.value,
      className: (0, _classnames.default)('p-2 cursor-pointer', {
        'bg-gray-lighter': index === highlightedIndex,
        'text-sm': size === 'small'
      })
    }, getItemProps({
      item: item,
      index: index
    })), item.label);
  })))));
}

Autocomplete.propTypes = {
  initialSearchTerm: (0, _propTypes2.requiredIf)(_propTypes.default.string, function (props) {
    return !props.onSearchChange;
  }),
  searchTerm: (0, _propTypes2.requiredIf)(_propTypes.default.string, function (props) {
    return props.onSearchChange;
  }),
  onSearchChange: _propTypes.default.func,
  name: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })).isRequired,
  onItemSelected: _propTypes.default.func.isRequired,
  placeholder: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  isDisabled: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'medium']),
  shouldShowChangeButton: _propTypes.default.bool,
  shouldAllowArbitraryInput: _propTypes.default.bool,
  filterFunc: _propTypes.default.func
};
Autocomplete.defaultProps = {
  initialSearchTerm: '',
  placeholder: 'Search',
  isLoading: false,
  isDisabled: false,
  searchTerm: '',
  shouldShowChangeButton: false,
  shouldAllowArbitraryInput: false,
  size: 'medium',
  filterFunc: defaultFilterFunc
};
var _default = Autocomplete;
exports.default = _default;